export default {
    name: 'Hiphone',
    fullName: 'Hiphone',
    url: 'https://themeforest.net/item/stroyka-tools-store-react-ecommerce-template/23909258',

    fb: 'https://www.facebook.com/Hiphone',
    instagram: 'https://www.instagram.com/light_and_more_llc/',
    author: {
        name: 'Kos',
        profile_url: 'https://themeforest.net/user/kos9',
    },
    contacts: {
        address: 'Հասցե։ Երևան, Հայաստան',
        email: 'marketing@megalight.am',
        phone: 'Հեռ: 374 93 99-10-93, 10 35-11-00',
    },
};
